import { persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';

import {
  IReducerPatrimoniesState,
  FETCH_PATRIMONY,
  FETCH_PATRIMONIES,
  PatrimoniesActionTypes,
} from './types';

const initialState: IReducerPatrimoniesState = {
  all: undefined,
  current: undefined,
};

const persistConfig = {
  storage,
  key: 'patrimonies',
  whitelist: ['all'],
};

const reducers = (state = initialState, action: PatrimoniesActionTypes) => {
  switch (action.type) {
    case FETCH_PATRIMONIES:
      return {
        ...state,
        all: action.payload,
      };
    case FETCH_PATRIMONY:
      return {
        ...state,
        current: action.payload,
      };

    default:
      return state;
  }
};

export default persistReducer(persistConfig, reducers);
